import React from "react";
import Tumbleweeds from "./Tumbleweeds";

/**
 * Sun-baked desert backdrop: gradient sky, distant mesas, cacti silhouettes,
 * sun disc, dust haze, and rolling tumbleweeds.
 */
const DesertScene = ({ children, withSun = true, intense = false }) => (
  <div
    className={`relative w-full overflow-hidden ${intense ? "bg-desert" : ""}`}
    style={
      intense
        ? {}
        : {
            background:
              "linear-gradient(to bottom, #f5d68b 0%, #ecaa55 35%, #c46a2c 70%, #6e3416 100%)",
          }
    }
  >
    {/* sun */}
    {withSun && (
      <div
        className="absolute rounded-full"
        style={{
          left: "50%",
          top: "18%",
          width: 220,
          height: 220,
          transform: "translateX(-50%)",
          background:
            "radial-gradient(circle, #ffe27a 0%, #ffb65a 40%, rgba(255,182,90,0) 72%)",
          filter: "blur(2px)",
          zIndex: 0,
        }}
      />
    )}

    {/* mesas */}
    <svg
      className="absolute bottom-0 left-0 w-full"
      viewBox="0 0 1200 240"
      preserveAspectRatio="none"
      style={{ height: "30%", zIndex: 1 }}
      aria-hidden
    >
      <polygon points="0,240 0,170 80,170 90,150 180,150 195,165 280,165 295,140 380,140 390,170 470,170 470,240" fill="#8b3a16" opacity="0.85" />
      <polygon points="430,240 430,180 540,180 555,165 660,165 675,150 770,150 780,170 880,170 880,240" fill="#6f2c10" opacity="0.95" />
      <polygon points="820,240 820,170 920,170 935,155 1030,155 1045,170 1140,170 1140,240 1200,240 1200,240" fill="#4d1d09" />
    </svg>

    {/* ground */}
    <div
      className="absolute bottom-0 left-0 right-0"
      style={{
        height: "18%",
        background: "linear-gradient(to bottom, #b9772f 0%, #6e3416 100%)",
        zIndex: 2,
      }}
    />

    {/* cacti silhouettes */}
    <svg
      className="absolute"
      style={{ left: "8%", bottom: "16%", height: "22%", zIndex: 3 }}
      viewBox="0 0 60 120"
      aria-hidden
    >
      <g fill="#3a1d0a">
        <rect x="26" y="20" width="10" height="100" rx="4" />
        <rect x="10" y="50" width="10" height="40" rx="4" />
        <rect x="42" y="40" width="10" height="50" rx="4" />
        <rect x="10" y="46" width="22" height="10" />
        <rect x="32" y="36" width="22" height="10" />
      </g>
    </svg>
    <svg
      className="absolute"
      style={{ right: "10%", bottom: "16%", height: "16%", zIndex: 3 }}
      viewBox="0 0 60 120"
      aria-hidden
    >
      <g fill="#2a1408">
        <rect x="26" y="30" width="10" height="90" rx="4" />
        <rect x="42" y="55" width="10" height="40" rx="4" />
        <rect x="32" y="51" width="22" height="10" />
      </g>
    </svg>

    <div className="dust-layer" style={{ zIndex: 4 }} />
    <Tumbleweeds />

    <div className="relative" style={{ zIndex: 10 }}>
      {children}
    </div>
  </div>
);

export default DesertScene;
